import {
  SETTING_SET_SODOR_DATE_FROM,
  SETTING_SET_SODOR_DATE_TO,
} from "constants/ActionTypes";
import { getLastMonth } from "layout/styles/global";

const INIT_STATE = {
  sodorDate: {
    fromDate: {
      value: getLastMonth(),
      error: "",
    },
    toDate: { value: new Date(), error: "" },
  },
};

const SettingReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SETTING_SET_SODOR_DATE_FROM: {
      return {
        ...state,
        sodorDate: { ...state.sodorDate, fromDate: action.payload },
      };
    }
    case SETTING_SET_SODOR_DATE_TO: {
      return {
        ...state,
        sodorDate: { ...state.sodorDate, toDate: action.payload },
      };
    }

    default:
      return state;
  }
};

export default SettingReducer;
